import {
	encode,
	decode
} from './secrect.js'
import {
	getColor,
	hexToRgba,
	changeOpacity,
	getSampleColor
} from './color.js'
import {
	setCookie,
	getCookie,
	removeCookie
} from './cookie.js'
import {
	Interval
} from './interval.js'
import {
	dom
} from './Dom.js'
import vue from 'vue'
var CommonM = {}
CommonM.checkString = function(e) {
	return typeof e == 'string' || "[object String]" === Object.prototype.toString.call(e)
}
//e为数字
CommonM.checkNumber = function(e) {
	return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e)
}
//e为时间
CommonM.checkDate = function(e) {
	return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e)
}
//e 为数组
CommonM.checkArray = function(e) {
	return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e)
}
CommonM.checkFunc = function(e) {
	return e instanceof Function || "[object Function]" === Object.prototype.toString.call(e)
}
//object
CommonM.checkObj = function(e) {
	return e instanceof Object || "[object object]" === Object.prototype.toString.call(e)
}
//object
CommonM.checkNormalNum = function(e) {
	return e != Infinity && !isNaN(e);
}
//时间戳转为日期格式
CommonM.getLocalTime = function(nS) {
	return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
}
CommonM.checkVNode = function(nS) {
	let _this = new vue();
	// 获取 vnode 实例
	let vnode = _this.$createElement('span', '')

	// VNode 构造函数
	let VNode = vnode.constructor

	// 所以通过 obj instanceof VNode 即可判断
	const isVNode = obj => obj instanceof VNode

	// 测试
	// isVNode({}) // false
	// isVNode(_this.$createElement('div', '')) // true
	return isVNode(nS);
}

/*
	url处理
*/

//获取url携带参数
CommonM.geturlparam = function() {
	let url = location.href;
	// url=decodeURIComponent(url)
	let param = url.replace('?', '?&').split('&');
	console.log(param)
	let res = {}
	for (let i = 1; i < param.length; i++) {
		let item = param[i].split('=')
		if (item.length == 2 && item[0] != '') {
			res[item[0]] = this.decodeurl(item[1])
		}
	}
	return res
}
//url解密
CommonM.decodeurl = function(str) {
	return decodeURIComponent(str)
}
//url加密
CommonM.encodeurl = function(str) {
	return encodeURIComponent(str)
}
//hash 就是一串字符
CommonM.hashCode = function(str) {
	if (Array.prototype.reduce) {
		return str.split("").reduce(function(a, b) {
			a = ((a << 5) - a) + b.charCodeAt(0);
			return a & a
		}, 0);
	}
	var hash = 0;
	if (str.length === 0) return hash;
	for (var i = 0; i < str.length; i++) {
		var character = str.charCodeAt(i);
		hash = ((hash << 5) - hash) + character;
		hash = hash & hash; // Convert to 32bit integer
	}
	return hash;
}
//本次存储加密解密
CommonM.LocalSet = function(str) {
	let newstr = '';
	if (!str) return str;
	if (this.checkObj(str)) {
		newstr = JSON.stringify(str);
	} else if (this.checkString(str)) {
		newstr = str;
	} else newstr = str;
	return encode(newstr);
}
CommonM.Localget = function(str) {
	let newstr = '';
	if (!str) return str;
	if (this.checkObj(str)) {
		newstr = JSON.stringify(str);
	} else if (this.checkString(str)) {
		newstr = str;
	} else newstr = str;
	return decode(newstr);
}
//获取相近的颜色
CommonM.getColor = function(str, opca, offset) {
	return getColor(str, opca, offset);
}
//颜色转为rgba
CommonM.hexToRgba = function(str, opca) {
	return hexToRgba(str, opca)
}
//修改颜色透明度
CommonM.changeOpacity = function(str, opca) {
	return changeOpacity(str, opca)
}

CommonM.getSampleColor = function(str, opca) {
	return getSampleColor(str, opca)
}
CommonM.cookies = {
	setCookie,
	getCookie,
	removeCookie
};
CommonM.Interval = Interval;
CommonM.AutoLogOut = function(outf) {
	var ltime = new Date().getTime(), // 最后一次点击的时间
		ctTime = new Date().getTime(), //当前时间
		tOut = 5 * 60 * 1000 //超时时间截至时间

	this.setLTime = function() {
		ltime = new Date().getTime();
	}
	this.start = function() {
		var inter = new Interval(() => {
			if (ctTime - ltime > tOut) {
				outf();
			}
		}, 1000);
		inter.start();
	}
}
CommonM.getDate = function(str) {
	var datetime = new Date();
	if (str) datetime = new Date(str);
	var year = datetime.getFullYear();
	var month = datetime.getMonth();
	var date = datetime.getDate();
	var day = datetime.getDay();
	month = month + 1;
	return {
		strValue: `${year}-${month}-${date}`,
		strForm23: `${year-2000}${month<10?('0'+month):month}${date<10?('0'+date):date}`,
		year,
		month,
		date,
		day
	}
}
CommonM.Dom = dom;
CommonM.GUID = function guid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx-xxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0,
			v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}
Date.prototype.format = function(format) {
	const centuryFromYear = year => {
		if (typeof year == 'string') {
			if (year.toString().slice(-2) == '00') {
				return year.toString().slice(0, 2);
			} else {
				return (Math.floor(+year / 100) + 1).toString();
			}
		} else if (typeof year == 'number') {
			return Math.floor((year - 1) / 100) + 1;
		} else {
			return undefined;
		}
	};
	var o = {
		"c+": centuryFromYear(this.getFullYear()),
		"C+": centuryFromYear(this.getFullYear()),
		"y+": this.getYear(),
		"Y+": this.getYear(),
		"M+": this.getMonth() + 1,
		"d+": this.getDate(),
		"D+": this.getDate(),
		"h+": this.getHours(),
		"H+": this.getHours(),
		"m+": this.getMinutes(),
		"s+": this.getSeconds(),
		"q+": Math.floor((this.getMonth() + 3) / 3),
		"S": this.getMilliseconds()
	}
	console.log(o)
	if (/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	if (/(Y+)/.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(format)) {
			format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k])
				.length));
		}
	}
	return format;
}
export default CommonM;
